module.exports = __webpack_public_path__ + "assets/discount_mobile-3153d5.svg";